/** @jsxImportSource @emotion/react */
import { Route, Routes } from 'react-router-dom';
import { TransactionDetails, TransactionList } from './components';

export const Transactions = () => {
  return (
    <Routes>
      <Route path="/" element={<TransactionList />} />
      <Route path="/:transactionId" element={<TransactionDetails />} />
    </Routes>
  );
};
